
import { useId, useRef } from "react";

export default function FieldAvatar({ avatar, avatarUrl, onChange }) {
	const inputId = useId();
	const inputRef = useRef(null);
	const selectedName = avatar instanceof File ? avatar.name : "";

	return (
		<div className="rounded-xl border border-[#E2E8F0] p-4">
			<p className="font-Vazir-500 text-[13px] text-grayText mb-3 text-center">عکس پروفایل</p>
			<div className="flex flex-col items-center gap-3">
				{avatarUrl && !(avatar instanceof File) ? (
					<img
						src={avatarUrl}
						alt=""
						className="h-24 w-24 rounded-full object-cover ring-2 ring-lightCta"
					/>
				) : null}
				<input
					ref={inputRef}
					id={inputId}
					type="file"
					accept="image/*"
					className="sr-only"
					onChange={(e) => {
						const file = e.target.files?.[0];
						if (file) onChange(file);
					}}
				/>
				<button
					type="button"
					className="font-Vazir-600 text-[13px] text-midGray px-4 py-2.5 rounded-xl border border-[#E2E8F0] bg-white hover:bg-lightCta hover:text-darkBlue transition-colors cursor-pointer"
					onClick={() => inputRef.current?.click()}
				>
					انتخاب تصویر
				</button>
				{selectedName ? (
					<p className="font-Vazir-400 text-[12px] text-grayText text-center break-all px-2">
						{selectedName}
					</p>
				) : (
					<p className="font-Vazir-400 text-[12px] text-grayText">فایلی انتخاب نشده</p>
				)}
			</div>
		</div>
	);
}
